import React from "react";
import "./styles.css";
import "react-dropzone-uploader/dist/styles.css";
import DropzoneUploader from "react-dropzone-uploader";
import { toast } from "react-toastify";
import { getUploadParams as getUploadParamsS3 } from "../../services/api.service";
import { CONTENT_TYPE } from "../UpdatedPage/UpdatedPage";

export const Dropzone = ({ setFilename }) => {
  const notifySuccess = () => toast.success("File uploaded successfully!");
  const notifyFailure = (text) => toast.error(text);

  // specify upload params and url for your files
  const getUploadParams = async ({ file, meta }) => {
    setFilename(meta.name);
    const fullUploadPath = meta.name;
    const extension = fullUploadPath.split(".").pop().toLowerCase();
    console.log(extension);
    console.log(CONTENT_TYPE[extension]);
    const response = await getUploadParamsS3(
      fullUploadPath,
      CONTENT_TYPE[extension]
    );
    const { url } = response.data;
    return { method: "PUT", body: file, url, headers: {} };
  };

  // called every time a file's `status` changes

  const handleChangeStatus = ({ meta, remove }, status) => {
    if (status === "headers_received") {
      notifySuccess();
    } else if (status === "rejected_file_type") {
      notifyFailure("File type invalid");
    } else if (status === "aborted") {
      notifyFailure("File upload failed");
    }
  };

  return (
    <DropzoneUploader
      styles={{
        inputLabel: {
          color: "white",
        },
        dropzoneActive: { borderColor: "green" },
      }}
      maxFiles={1}
      multiple={false}
      canCancel={false}
      getUploadParams={getUploadParams}
      onChangeStatus={handleChangeStatus}
      inputContent="Drop A File"
      accept={Object.values(CONTENT_TYPE).join(",")}
      data-cy="drag-and-drop"
      classNames={`drag-and-drop`}
    />
  );
};
